import type { AppDescription } from "@glide/app-description";
import { Icon } from "@glide/common-core/dist/js/render/icon";

import { UnifiedProjectIcon } from "./unified-project-icon";

interface AppIconProps {
    readonly theme: AppDescription["theme"];
    readonly iconImage: AppDescription["iconImage"];
    readonly iconSize?: number;
    readonly appID: string;
}

export const AppOrPageIcon: React.FC<AppIconProps> = p => {
    const { theme, iconImage, iconSize = 32, appID } = p;

    // TODO: When this feature is turned on, we should remove this component
    return (
        <UnifiedProjectIcon
            classicIcon={
                <Icon
                    clipCorners={true}
                    color={theme.primaryAccentColor}
                    size={iconSize}
                    image={iconImage}
                    appID={appID}
                />
            }
        />
    );
};
